import TypographyCom from './Typography';

export default TypographyCom;
